import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { _SERVEROOT } from 'src/app/routes/server-root';
import { EntrepotModel } from '../../model/wh/entrepot.service';

@Injectable({
  providedIn: 'root'
})
export class EntrepotService {

  constructor(
    public http: HttpClient,
    public model: EntrepotModel
  ) { }

  public add(){
    return this.http.post(_SERVEROOT.whentrepots_post,this.model);
  }

  public get(){
    return this.http.get(_SERVEROOT.whentrepots_get);
  }

  public update(id : any){
    return this.http.put(_SERVEROOT.whentrepots_update+id,this.model)
  }
}
